import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function LHWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1644">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1645">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1646">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-1647">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1648">
              <img src="https://cdn.magicpatterns.com/uploads/jTWP7dH9zmAhDdfxmDnAkH/BeClinical-Lifestyle-31-2.jpg" alt="Be CLINICAL Laser Hair Removal Specialist" className="w-full h-full object-cover" data-id="element-1649" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-1650">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1651">
              WHY CHOOSE BE CLINICAL FOR LASER HAIR REMOVAL?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-1652"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-1653">
              <p data-id="element-1654">
                At Be CLINICAL, we recognize the transformative impact of
                radiant skin on self-assurance and confidence. That's why our
                laser hair removal treatment is meticulously tailored to not
                only deliver stunning results, but also to make your daily
                beauty regimen faster and easier. Utilizing the most advanced
                Candela GentleMax Pro laser system, we're dedicated to helping
                you attain the glowing, hair-free skin you crave, empowering you
                to face each day with renewed vitality.
              </p>
              <p data-id="element-1655">
                Led by the expertise of Dr. Fiona Frie, our physician-owned and
                operated San Ramon clinic has upheld the principles of safety,
                quality, and efficacy since its establishment in 2017. Choose Be
                CLINICAL for a skincare journey that transcends the surface,
                rejuvenating both your skin and your spirit. We invite you to
                schedule your complimentary consultation today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1656">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}